import { X, Check } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const rows = [
  ["Rigid, exhausting group bus schedules", "Private Innova Crysta matching your pace"],
  ["Blindly booking unverified hotels", "100% Vetted, hygienic 4★ eco-resorts"],
  ["15-minute rushed photo stops", "Quiet valley cafés and deep local stories"],
  ["Stress over regional meal barriers", "Partner-vetted South Indian & Veg comforts"],
];

export const Comparison = () => (
  <section className="bg-[#F1EEE7] px-7 py-24 sm:px-12 lg:px-20 lg:py-32" data-testid="comparison-section">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="eyebrow text-gold mb-5">The Positioning Shift</p>
        <h2 className="font-display text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl max-w-3xl">
          We built our agency to do the <span className="italic text-gold">exact opposite.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-16">
        {/* Mass market */}
        <Reveal>
          <div className="border border-black/10 bg-white/40 p-8 lg:p-10">
            <p className="eyebrow text-black/40 mb-8">Instead of Mass-Market Tourism</p>
            <ul className="space-y-6">
              {rows.map(([bad]) => (
                <li key={bad} className="flex items-start gap-4">
                  <X className="mt-0.5 h-5 w-5 shrink-0 text-black/30" strokeWidth={2} />
                  <span className="text-base text-black/45 line-through decoration-black/20">{bad}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        {/* Boutique */}
        <Reveal delay={0.12}>
          <div className="relative border border-gold/40 bg-ink p-8 shadow-xl lg:p-10">
            <p className="eyebrow text-gold mb-8">The Boutique Difference</p>
            <ul className="space-y-6">
              {rows.map(([, good]) => (
                <li key={good} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold">
                    <Check className="h-3 w-3 text-ink" strokeWidth={3} />
                  </span>
                  <span className="text-base font-medium text-white">{good}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
